'use client'

import { useEffect, useState } from 'react'

const FONT_CLASS_MAP = {
  Inter: 'font-inter',
  Roboto: 'font-roboto',
  'Open Sans': 'font-opensans',
  Lora: 'font-lora',
  Poppins: 'font-poppins',
  'Playfair Display': 'font-playfair',
  Montserrat: 'font-montserrat',
}

function setCSSVariable(key, value) {
  document.documentElement.style.setProperty(`--${key}`, value)
}

export default function FontChanger() {
  const [showPanel, setShowPanel] = useState(false)
  const [font, setFont] = useState('Inter')
  const [colors, setColors] = useState({
    maincolor: '#1b2f6b',
    secondarycolor: '#05294d',
    thirdcolor: '#941109',
    fourthcolor: '#941109',
    textcolor: '#05294d',
    pricecolor: '#e3e3e3',
    labelcolor: '#1b2f6b',
    labelhighlight: '#1b2f6b',
    iconcolor: '#1b2f6b',
  })

  useEffect(() => {
    const savedColors = {
      maincolor: localStorage.getItem('maincolor') || '#1b2f6b',
      secondarycolor: localStorage.getItem('secondarycolor') || '#05294d',
      thirdcolor: localStorage.getItem('thirdcolor') || '#941109',
      fourthcolor: localStorage.getItem('fourthcolor') || '#e3e3e3',
      textcolor: localStorage.getItem('textcolor') || '#05294d',
      pricecolor: localStorage.getItem('pricecolor') || '#941109',
      labelcolor: localStorage.getItem('labelcolor') || '#1b2f6b',
      labelhighlight: localStorage.getItem('labelhighlight') || '#1b2f6b',
      iconcolor: localStorage.getItem('iconcolor') || '#1b2f6b',
    }

    setColors(savedColors)
    Object.entries(savedColors).forEach(([key, value]) => {
      setCSSVariable(key, value)
    })

    const savedFont = localStorage.getItem('app-font') || 'Montserrat'
    setFont(savedFont)
    updateHtmlClass(savedFont)
  }, [])

  const updateHtmlClass = (fontName) => {
    const html = document.documentElement
    // Remove all other font classes
    Object.values(FONT_CLASS_MAP).forEach((cls) => html.classList.remove(cls))
    html.classList.add(FONT_CLASS_MAP[fontName])
  }

  const handleChange = (e) => {
    const newFont = e.target.value
    setFont(newFont)
    localStorage.setItem('app-font', newFont)
    updateHtmlClass(newFont)
  }

  const handleColorChange = (key) => (e) => {
    const newColor = e.target.value
    const updatedColors = { ...colors, [key]: newColor }
    setColors(updatedColors)
    localStorage.setItem(key, newColor)
    setCSSVariable(key, newColor)
  }

  return (
    <div className='fixed z-[100] sm:bottom-10 bottom-[75px] sm:right-10 right-[20px]'>
      {showPanel ? (
        <div className="p-2 rounded-md border border-gray-200 bg-white ">
          <div className='w-full flex justify-end'>
            <span onClick={() => {setShowPanel(false)}} className='bg-red-500 flex items-center justify-center p-1 rounded-sm text-white cursor-pointer'>X</span>
          </div>
          {Object.entries(colors).map(([key, value]) => (
            <div key={key} className="mb-2">
              <label className="block mb-1 font-medium">
                Choose {key.replace('color', '') || 'Color'}
              </label>
              <input type="color" value={value} onChange={handleColorChange(key)} />
            </div>
          ))}
          <label className="mr-2">Choose Font:</label>
          <select value={font} onChange={handleChange} className="border p-2">
            {Object.keys(FONT_CLASS_MAP).map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>) : (
          <div className='p-2 rounded-md border border-gray-200 bg-white cursor-pointer' onClick={() => {setShowPanel(true)}}>Admin Panel</div>
        )}
    </div>
  )
}
